import { getGraphQLClient } from "@lib/graphql-client"
import { useQuery } from "@tanstack/react-query"
import { useRouter } from "next/router"

const { sdk } = getGraphQLClient()

export function useBaseData() {
  const { query } = useRouter()
  const baseId = query && query.base ? (query.base as string) : null
  const { data: baseData } = useQuery(["article", baseId], () =>
    sdk.Article({ id: baseId })
  )
  return baseData
}
